export const modelOptions = [
  { value: 'openmeteo', label: 'Catamaran Weather' },
  { value: 'xweather', label: 'Catamaran SCS' },
  { value: 'drought', label: 'Drought Data' },
  { value: 'shipping', label: 'Shipping & Marine' }
];

export const xweatherParameters = {
  "Storm Reports": "storm_reports",
  "Tropical Cyclones": "tropicalcyclones"
};

export const openmeteoParameters = {
  "Max Temperature": "temperature_2m_max",
  "Min Temperature": "temperature_2m_min",
  "Max Apparent Temperature": "apparent_temperature_max",
  "Min Apparent Temperature": "apparent_temperature_min",
  "Precipitation Sum": "precipitation_sum",
  "Rain Sum": "rain_sum",
  "Showers Sum": "showers_sum",
  "Snowfall Sum": "snowfall_sum",
  "Precipitation Hours": "precipitation_hours",
  "Daily Precipitation Probability": "precipitation_probability_max",
  "Min Precipitation Probability": "precipitation_probability_min",
  "Mean Precipitation Probability": "precipitation_probability_mean",
  "Max Wind Speed (10m)": "wind_speed_10m_max",
  "Max Wind Gusts (10m)": "wind_gusts_10m_max",
  "Dominant Wind Direction (10m)": "wind_direction_10m_dominant",
  "Shortwave Radiation Sum": "shortwave_radiation_sum",
  "ET0 FAO Evapotranspiration": "et0_fao_evapotranspiration",
  "Max UV Index": "uv_index_max",
  "Max Clear Sky UV Index": "uv_index_clear_sky_max"
};

export const stormFilters = [
  { value: 'all', text: 'All Reports' },
  { value: 'blizzard', text: 'Blizzard' },
  { value: 'flood', text: 'Flood' },
  { value: 'ice', text: 'Ice' },
  { value: 'hail', text: 'Hail' },
  { value: 'rain', text: 'Rain' },
  { value: 'snow', text: 'Snow' },
  { value: 'tornado', text: 'Tornado' },
  { value: 'wind', text: 'Wind' }
];

export const queryOptions = [
  { value: 'none', text: 'None' },
  { value: 'type', text: 'Type' },
  { value: 'detail', text: 'Detail' },
  { value: 'comments', text: 'Comments' }
];

export const vesselTypes = [
  { value: 'container', text: 'Container Ship' },
  { value: 'bulk', text: 'Bulk Carrier' },
  { value: 'tanker', text: 'Oil Tanker' },
  { value: 'cargo', text: 'General Cargo' },
  { value: 'roro', text: 'Roll-on/Roll-off' }
];

export const coverageTypes = [
  { value: 'trade_credit', text: 'Trade Credit Insurance' },
  { value: 'parametric', text: 'Parametric Hurricane Coverage' },
  { value: 'marine_cargo', text: 'Marine Cargo Coverage' }
];